const StartStopIcon = ({ state }) => {
  const startRecordingIcon = (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.44 24C37.44 31.4227 31.4227 37.44 24 37.44C16.5773 37.44 10.56 31.4227 10.56 24C10.56 16.5773 16.5773 10.56 24 10.56C31.4227 10.56 37.44 16.5773 37.44 24Z"
        fill="#CCDBF0"
      />
      <path
        d="M42.2 24C42.2 34.0516 34.0516 42.2 24 42.2C13.9484 42.2 5.79999 34.0516 5.79999 24C5.79999 13.9484 13.9484 5.8 24 5.8C34.0516 5.8 42.2 13.9484 42.2 24ZM36.44 24C36.44 30.8704 30.8704 36.44 24 36.44C17.1296 36.44 11.56 30.8704 11.56 24C11.56 17.1296 17.1296 11.56 24 11.56C30.8704 11.56 36.44 17.1296 36.44 24ZM24 38.44C31.975 38.44 38.44 31.975 38.44 24C38.44 16.025 31.975 9.56 24 9.56C16.025 9.56 9.56002 16.025 9.56002 24C9.56002 31.975 16.025 38.44 24 38.44Z"
        stroke="#CCDBF0"
        strokeWidth="2"
      />
    </svg>
  );

  const stopRecordingIcon = (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.79999"
        y="4.8"
        width="38.4"
        height="38.4"
        rx="8"
        fill="#CCDBF0"
      />
    </svg>
  );
  return (
    <>
      {(() => {
        if (state === "Record") {
          return startRecordingIcon;
        } else if (state === "Stop") {
          return stopRecordingIcon;
        }

        return null;
      })()}
    </>
  );
};

export default StartStopIcon;
